import { useState, useCallback } from 'react';
 
export const useRecipeTime = (initialTimes = {}) => {
  const [recipeTimes, setRecipeTimes] = useState({
    soak: initialTimes.soak || 0,
    pickle: initialTimes.pickle || 0,
    basic: initialTimes.basic || 0,
    cool: initialTimes.cool || 0,
    infusion: initialTimes.infusion || 0,
    freeze: initialTimes.freeze || 0,
  });
  
  const [timeUnits, setTimeUnits] = useState({
    soak: 'мин',
    pickle: 'мин',
    basic: 'мин',
    cool: 'мин',
    infusion: 'мин',
    freeze: 'мин',
  });
   
  
  // Конвертация в минуты
  const convertToMinutes = useCallback((value, unit) => {
    if (!value || value <= 0) return 0;
    
    switch (unit) {
      case 'час':
      case 'часы':
      case 'hours':
        return value * 60;
      case 'день':
      case 'дни':
      case 'days':
        return value * 1440;
      default:
        return value;
    }
  }, []);
  
  const handleTimeChange = useCallback((timeKey, value, unit) => {
    console.log(timeKey, value, unit); 
    
    setRecipeTimes(prev => ({
      ...prev,
      [timeKey]: value
    }));
    
    if (unit) {
      setTimeUnits(prev => ({
        ...prev,
        [timeKey]: unit
      }));
    }
  }, []);
  
  const handleUnitChange = useCallback((timeKey, unit) => {
    setTimeUnits(prev => ({
      ...prev,
      [timeKey]: unit
    }));
  }, []);
  
  // Расчет общего времени в минутах
  const calculateTotalTime = useCallback(() => {
    let total = 0;
    Object.entries(recipeTimes).forEach(([key, value]) => {
      if (value > 0) {
        total += convertToMinutes(value, timeUnits[key]);
      }
    });
    return total;
  }, [recipeTimes, timeUnits, convertToMinutes]);
  
  // 🔥 Получить данные для отправки на сервер (все в минутах)
  const getTimesForServer = useCallback(() => {
    const serverTimes = {};
    
    Object.entries(recipeTimes).forEach(([key, value]) => {
      if (value > 0) {
        // Конвертируем в минуты
        serverTimes[key] = convertToMinutes(value, timeUnits[key]);
      } else {
        serverTimes[key] = 0;
      }
    });
    
    return serverTimes;
  }, [recipeTimes, timeUnits, convertToMinutes]);
  
  // 🔥 Получить только активные времена (для сервера, без нулей)
  const getActiveTimesForServer = useCallback(() => {
    const activeTimes = {};
    
    Object.entries(recipeTimes).forEach(([key, value]) => {
      if (value > 0) {
        activeTimes[key] = convertToMinutes(value, timeUnits[key]);
      }
    });
    
    return activeTimes;
  }, [recipeTimes, timeUnits, convertToMinutes]);
  
  const resetTimes = useCallback(() => {
    setRecipeTimes({
      soak: 0,
      pickle: 0,
      basic: 0,
      cool: 0,
      infusion: 0,
      freeze: 0,
    });
    setTimeUnits({
      soak: 'мин',
      pickle: 'мин',
      basic: 'мин',
      cool: 'мин',
      infusion: 'мин',
      freeze: 'мин',
    });
  }, []);
  
  // Валидация обязательного поля basic
  const isValid = useCallback(() => {
    const basicValue = recipeTimes.basic;
    const basicUnit = timeUnits.basic;
    const basicInMinutes = convertToMinutes(basicValue, basicUnit);
    return basicInMinutes > 0;
  }, [recipeTimes.basic, timeUnits.basic, convertToMinutes]);
  
  return {
    recipeTimes,      // исходные значения (как ввел пользователь)
    timeUnits,        // выбранные единицы измерения
    handleTimeChange,
    handleUnitChange,
    calculateTotalTime,      // общее время в минутах
    getTimesForServer,       // все времена в минутах (с нулями)
    getActiveTimesForServer, // только активные времена в минутах
    resetTimes,
    isValid
  };
};